import { render, staticRenderFns } from "./ProductDimensions.vue?vue&type=template&id=76de4634&"
import script from "./ProductDimensions.vue?vue&type=script&lang=js&"
export * from "./ProductDimensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports